// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
 
import { useDispatch } from 'react-redux';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import React, { Fragment, useEffect, useRef, useState , Suspense } from 'react'

// import "../../style.css";
import { useIntl } from 'react-intl';
import PaidIcon from '@mui/icons-material/Paid';

const formatAmount = (value, alwaysPositive = false) => {
  if (value === null || value === undefined || value === '') return '';
  let num = parseFloat(value);
  if (Number.isNaN(num)) return value;
  if (alwaysPositive) num = Math.abs(num);
  return num.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 });
};

const TableStatistics = ({ transactionsNumber, transactionsTotalAmount, transactionsTotalCredits, transactionsTotalDebits }) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const intl = useIntl();
  return (
    <div className="table-data-more-analysis" >
      <>
        <span className='show-span'>
          <bdi style={{ margin: "5px" }}> {intl.formatMessage({ id: 'NoOfTransactions' })} : </bdi>
        </span>
        {transactionsNumber}
      </>
      
      {transactionsTotalAmount && <>
        <span className='act-as-table' style={{ marginLeft: "8px", marginRight: "8px" }}> </span>
        <span className='show-span'>
          <bdi style={{ margin: "5px" }}>{intl.formatMessage({ id: 'totalAmount' })} : </bdi>
        </span>
        {formatAmount(transactionsTotalAmount)} {intl.formatMessage({ id: 'currency' })}
      </>}
    
      {transactionsTotalCredits && <>
        <span className='act-as-table' style={{ marginLeft: "8px", marginRight: "8px" }}> </span>
        <span className='show-span'>
          <bdi style={{ margin: "5px" }}>{intl.formatMessage({ id: 'totalCredits' })} : </bdi>
        </span>
        {formatAmount(transactionsTotalCredits)} {intl.formatMessage({ id: 'currency' })}
      </>}
     
      {transactionsTotalDebits && <>
        <span className='act-as-table' style={{ marginLeft: "8px", marginRight: "8px" }}> </span>
        <span className='show-span'>
          <bdi style={{ margin: "5px" }}>{intl.formatMessage({ id: 'totalDebits' })} :</bdi>
        </span>
        {formatAmount(transactionsTotalDebits, true)} {intl.formatMessage({ id: 'currency' })}
      </>}
    </div>
  )
};

export { TableStatistics };
